import type { OrganizationProviderConfig } from '@openx/components-organization/lib/utils/context/OrganizationContext.tsx';
import { useApiKeyCreate } from './utils/useApiKeyCreate.tsx';
import { useApiKeyDelete } from './utils/useApiKeyDelete.ts';
import { useCreateOrganization } from './utils/useCreateOrganization.ts';
import { useDspSeatsFetch } from './utils/useDspSeatsFetch.ts';
import { useDspsFetch } from './utils/useDspsFetch.ts';
import { useEditOrganization } from './utils/useEditOrganization.ts';
import { useGetDefaultParentOrganizationId } from './utils/useGetDefaultParentOrganizationId.ts';
import { useGetOrganizationsTableData } from './utils/useGetOrganizationsTableData.tsx';
import { useOrganizationApiKeysFetch } from './utils/useOrganizationApiKeysFetch.ts';
import { useOrganizationFetch } from './utils/useOrganizationFetch.ts';
import { useOrganizationPageHeaderActions } from './utils/useOrganizationPageHeaderActions.tsx';
import { useOrganizationPermissions } from './utils/useOrganizationPermissions.ts';
import { useOrganizationPixelMetricsFetch } from './utils/useOrganizationPixelMetricsFetch.ts';
import { useOrganizationsListFetch } from './utils/useOrganizationsListFetch.ts';
import { useOrganizationUsersFetch } from './utils/useOrganizationUsersFetch.ts';

export const organizationConfig: OrganizationProviderConfig = {
  isOa: true,
  useOrganizationFetch,
  useOrganizationsListFetch,
  useOrganizationUsersFetch,
  useOrganizationPageHeaderActions,
  useGetOrganizationsTableData,
  useOrganizationApiKeysFetch,
  useOrganizationPixelMetricsFetch,
  useApiKeyDelete,
  useGetDefaultParentOrganizationId,
  useCreateOrganization,
  useEditOrganization,
  useOrganizationPermissions,
  useApiKeyCreate,
  useDspsFetch,
  useDspSeatsFetch,
};
